import { h, Component } from 'preact';
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import util from '../util';
import store from '../store';

import Renderer from '../canvas/renderer';

import PositionTools from './PositionTools';
import ResizeWidget from './ResizeWidget';
import FlipWidget from './FlipWidget';
import ImageBorderWidget from "./ImageBorderWidget";
import SwapPhotoWidget from "./mobile/SwapPhotoWidget";
import constants from "../constants";
import { startRepositionFrame, adjustAfterBorderChange } from "../canvas/reposition-frame";
import GroupBarListItem from "./GroupBarListItem";
import HyperlinkWidget from './HyperlinkWidget'
import { UnlockOutlined, LockOutlined, DeleteOutlined } from "@ant-design/icons";
import { canDisplayAlign } from "../canvas/component";
import ADAIcon from './icon/ADAIcon';

export default @connect(reduce, actions)
class VideoFrameBar extends Component {
  constructor() {
    super();

    this.state = {
      borderColor: '000000',
    };

    this.removeElement = () => {
      this.props.deselect();
      Renderer.remove(this.props.multiselect ? this.props.$elements : this.props.$element, this.props.multiselect);
    };

    this.removeImage = () => {
      Renderer.removeFrameImage(this.props.multiselect ? this.props.$elements : this.props.$element);
    };

    this.updateBorderRadius = (ev) => {
      const val = ev.target.value;
      const $element = this.props.$element.find('video');

      const isPercent = $element.css('borderRadius').indexOf('%') > -1;
      let radius = isPercent ? `${val / 2}%` : val / 10 + 'em';
      Renderer.updateElementStyle($element, 'borderRadius', radius);
      $element.attr('data-border-radius', val);
      this.props.updateElementAttribute('borderRadius', val);
    };

    this.updateBorderWidth = (ev) => {
      const val = ev.target.value;
      const $element = this.props.$element.find('video');
      const oldVal = $element.attr('data-border-width');

      Renderer.updateElementStyle($element, 'borderWidth', val / 10 + 'em');
      $element.attr('data-border-width', val);

      if (val > 0) Renderer.updateElementStyle($element, 'borderStyle', 'solid');
      this.props.updateElementAttribute('borderWidth', val);

      // if ($element.css('background-size') !== 'cover') {
      //   const $target = $element.parent();
      //   adjustAfterBorderChange($target, oldVal - val);
      // }
    };

    this.copyElement = () => {
      Renderer.copy(this.props.multiselect ? this.props.$elements : this.props.$element);
    };
    this.copyGroup = () => {
      Renderer.copy(this.props.$element.parents('.group'));
    };

    this.changeBorderColor = (color) => {
      Renderer.updateElementStyle(this.props.$element.find('video'), 'borderColor', color);
      this.props.updateElementAttribute('borderColor', color);
    };

    this.clearBorder = () => {
      Renderer.updateElementStyle(this.props.$element.find('video'), 'borderColor', constants.DEFAULT_TEXT_COLOR);
      Renderer.updateElementStyle(this.props.$element.find('video'), 'borderWidth', 0);
      this.props.updateElementAttribute('borderWidth', '0');
      this.props.updateElementAttribute('borderColor', constants.DEFAULT_TEXT_COLOR);
    };

    this.fixImagePath = () => {
      const path = Renderer.getImagePath(this.props.$element);
      this.props.showFixImageModal(path);
    };

    this.ungroup = () => {
      Renderer.ungroup(this.props.$element);
    };

    this.updateOpacity = (ev) => {
      const val = ev.target.value;
      const $elem = util.getElementContent(this.props.$element);

      Renderer.updateElementStyle($elem, 'opacity', val / 100);
      this.props.updateElementAttribute('opacity', val);
    };

    this.toggleLock = () => {
      if (this.props.isLocked) {
        Renderer.unlock(this.props.multiselect ? this.props.$elements : this.props.$element);
      } else {
        Renderer.lock(this.props.multiselect ? this.props.$elements : this.props.$element);
      }
      this.props.updateElementAttribute('isLocked', !this.props.isLocked);
    }

    this.replaceFrameImage = () => {
      store.dispatch(actions.goToView('graphics'));
      store.dispatch(actions.goToSubview('root'));
      store.dispatch(actions.setReplaceFrameMode(true));
    }

    this.repositionImage = () => {
      const $element = this.props.$element;
      startRepositionFrame($element);
    }

    this.openColorPicker = () => {
      util.openColorPicker(constants.pickerTypes.videoFrameBorder);
    }

    this.handleTrash = (ev) => {
      if (this.props.multiselect) {
        const $elements = this.props.$elements;
        let hasPhoto = $elements.some(function ($el) {
          return !$el.find('video').css('background-image').includes('img-plc');
        })
        if (!hasPhoto) {
          this.removeElement();
        }
      } else {
        const $element = this.props.$element;
        if ($element.find('video').css('background-image').includes('img-plc')) {
          this.removeElement();
        }
      }
    }

    this.goToAdjusts = () => {
      this.props.goToView('video-adjusts');
    }

    this.mute = () => {
      const $elem = util.getElementContent(store.getState().$element).find('video').get(0);

      Renderer.updateElementMuted($elem, true);
      store.dispatch(actions.updateElementAttribute('muted', true));
    }

    this.unmute = () => {
      const $elem = util.getElementContent(store.getState().$element).find('video').get(0);

      Renderer.updateElementMuted($elem, false);
      store.dispatch(actions.updateElementAttribute('muted', false));
    }
  }

  componentDidMount() {
    this.setDefaultBorderColor();
  }

  setDefaultBorderColor() {
    if (!!this.props.borderColor && this.state.borderColor !== this.props.borderColor.slice(1)) {
      this.setState({ borderColor: this.props.borderColor.slice(1) });
    }
  }

  render(props, state) {

    const copyOptions = props.isInGroup ?
      <a className="icn rwd-icon hint--bottom" data-hint="Duplicate" onClick={this.copyGroup}><span>Copy</span>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"} />
        </svg>
      </a> :
      <a className="icn rwd-icon hint--bottom" data-hint="Duplicate" onClick={this.copyElement}><span>Copy</span>
        <svg>
          <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-copy"} />
        </svg>
      </a>;

    //const fixItOption = props.isAdmin || props.isDesigner ? <li><a onClick={this.fixImagePath} className="red bold" style="display: none">Fix it</a></li> : null;

    const elementOptions = !props.isLocked ?
      <ul className="secondary">
        {/*{fixItOption}*/}
        <li className={!props.isInGroup ? 'hidden' : ''}>
          <a className="icn rwd-icon ungroup-btn" onClick={this.ungroup}>
            <span>Ungroup</span>
          </a>
        </li>
        <li>
          <a className="hint--bottom mobile-tool-widget" data-hint="ADA Text" onClick={() => store.dispatch(actions.setIsAltTextModal(true))}>
            <ADAIcon/>
            {props.isMobileVersion && <span>ADA Text</span>}
          </a>
        </li>
        {props.multiselect && <GroupBarListItem {...props} />}
        {canDisplayAlign(props.$element) && <li>
          <PositionTools />
        </li>}
        <span className="separator"></span>
        {/*<li>
          <HyperlinkWidget $element={props.$element} href={props.href} isHyperlink={props.isHyperlink} updateElementAttribute={props.updateElementAttribute} hasPdfPermission={props.hasPdfPermission} setActiveMember={props.setActiveMember} />
        </li>*/}
        <span className="separator"></span>
        <li>
          {copyOptions}
        </li>

        <li>
          <a className="icn rwd-icon hint--bottom" data-hint="Lock" onClick={this.toggleLock}>
            <UnlockOutlined />
          </a>
        </li>

        {!props.isMobileVersion &&
          <li>
            <div className="dropdown sizes">
              <a className="dropdown-toggle icn rwd-icon hint--bottom" data-hint="Delete" onClick={this.removeElement}>
                <DeleteOutlined />
              </a>
            </div>
          </li>}
      </ul>
      :
      <ul className="secondary">
        <li>
          <a className="hint--bottom mobile-tool-widget" data-hint="ADA Text" onClick={() => store.dispatch(actions.setIsAltTextModal(true))}>
            <ADAIcon/>
            {props.isMobileVersion && <span>ADA Text</span>}
          </a>
        </li>
        <li>
          <a className="icn tgl act rwd-icon hint--bottom" data-hint="Unlock" onClick={this.toggleLock}>
            <LockOutlined />
          </a>
        </li>
        <li>
          <a className="locked-label hint--bottom" data-hint="Unlock" onClick={this.toggleLock}>Locked</a>
        </li>
      </ul>;

    return (
      <div className="context-bar">
        <ul>
          {props.isMobileVersion &&
            <li>
              <div className="dropdown sizes">
                <a className="dropdown-toggle icn rwd-icon hint--bottom" data-hint="Delete" onClick={(ev) => this.handleTrash(ev)}>
                  <DeleteOutlined />
                </a>
                <div className="dropdown-menu" style="right: 0; width: auto;">
                  <ul className="slider-list">
                    <li>
                      <a onClick={this.removeElement}>Delete</a>
                    </li>
                    <li>
                      <a onClick={this.removeImage}>Remove Photo</a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>}

          {!props.multiselect && props.isMobileVersion &&
            <li>
              <div className="dropdown sizes">
                <a className="dropdown-toggle car">
                  Swap
                </a>
                <div className="dropdown-menu auto" data-close="no">
                  <SwapPhotoWidget />
                </div>
              </div>
            </li>}
          {!props.multiselect && props.isMobileVersion && <span className="separator"></span>}

          {!props.multiselect && !props.isMobileVersion &&
            <li>
              <div className="dropdown sizes">
                <a className="dropdown-toggle car" data-hint="Swap" onClick={this.replaceFrameImage}>
                  Replace
                </a>
              </div>
            </li>}
          {!props.multiselect && !props.isMobileVersion && <span className="separator"></span>}

          {/* {!props.multiselect && !props.isLocked &&
            <li>
              <div className="dropdown sizes">
                <a className="dropdown-toggle car" data-hint="Swap" onClick={this.repositionImage}>
                  Crop
                </a>
              </div>
            </li>}
          {!props.multiselect && !props.isLocked &&
            <span className="separator"></span>} */}

          {!props.multiselect &&
            <li>
              <ImageBorderWidget
                width={props.borderWidth}
                color={props.borderColor}
                value={props.borderRadius}
                withNoBorder={false}
                onWidthUpdate={this.updateBorderWidth}
                onColorUpdate={this.changeBorderColor}
                onClearBorder={this.clearBorder.bind(this)}
                openColorPicker={this.openColorPicker}
                $element={this.props.$element}
                updateBorderRadius={this.updateBorderRadius.bind(this)} />
            </li>}
          {!props.multiselect && <span className="separator"></span>}

          {!props.multiselect && <li>
            <div className="dropdown sizes">
              <a className="dropdown-toggle icn rwd-icon hint--bottom" data-hint="Opacity">
                <svg>
                  <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-opacity"} />
                </svg>
              </a>
              <div className="dropdown-menu auto" data-close="no">
                <ul className="slider-list">
                  <li className="slider-item">
                    <div className={'slider-wrap'}>
                      <label>Opacity</label>
                      <div className="toolbar-wrap">
                        <input className="slider" type="range" min="0" max="100" step="1" value={props.opacity} onChange={this.updateOpacity} onMouseMove={this.updateOpacity} />
                      </div>
                      <input className="value" type="number" min="0" max="100" step="1" disabled="disabled" value={Math.round(props.opacity)} />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </li>}

          {!props.multiselect && <span className="separator"></span>}
          {!props.multiselect && <li>
            <FlipWidget />
          </li>}

          {/* {!props.multiselect && <span className="separator"></span>}
          {!props.multiselect && <li>
            <a className="icn rwd-icon hint--bottom" data-hint="Trim">
              <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-trim"} /></svg>
            </a>
          </li>} */}

          {!props.multiselect && <span className="separator"></span>}
          {!props.multiselect && <li>
            <a className={`icn rwd-icon hint--bottom ${props.view === "video-adjusts" ? "act" : ""}`} data-hint="Adjust" onClick={() => this.goToAdjusts()}>
              <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-adjust"} /></svg>
            </a>
          </li>}

          {!props.multiselect && <span className="separator"></span>}
          {!props.multiselect && <li>
            {store.getState().muted ?
              <a className={`icn rwd-icon hint--bottom act`} data-hint="Unmute" onClick={() => this.unmute()}>
                <svg className="mute"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-mute"} /></svg>
              </a> :
              <a className={`icn rwd-icon hint--bottom`} data-hint="Mute" onClick={() => this.mute()}>
                <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-unmute"} /></svg>
              </a>
            }
          </li>}

          {!props.multiselect && (props.isAdmin || props.isDesigner) && <span className="separator"></span>}
          {(props.isAdmin || props.isDesigner) && <li>
            <ResizeWidget />
          </li>}

          {/* {!props.multiselect && (props.isAdmin || props.isDesigner) && <span className="separator"></span>}
          {props.$element && props.$element.find('video').get(0) &&
            <li>
              <a className={`hint--bottom`} data-hint="Duration">
                {parseInt(props.$element.find('video').get(0).duration)}s
              </a>
            </li>
          } */}

        </ul>

        {elementOptions}
      </div>
    )
  }
}
